import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export const INDETERMINATE_PROGRESS = -10000;
export const FAILURE_PROGRESS = -10001;
export const HIDE_PROGRESS = -10002;
export const SUCCESS_PROGRESS = 100;

export interface TrayTask {
  id: string;
  heading: string;
  onHeadingClick: (() => void) | undefined;
  subheading: string;
  onSubheadingClick: (() => void) | undefined;
  icon: BenchlingIconName | undefined;
  progress: number;
  error: string;
}
